export default __webpack_public_path__ + "static/Shilpi-80c580d40bdc465828a3410fe58fd16f.png";